export const siteConfig = {
  name: "KKN-PLP Terintegrasi Angkatan 65",
  shortName: "KKN 55",
  group: "Kelompok 55",
  tagline: "Gerakan Eco Masjid melalui sedekah Sampah.",
  subtitle: "Pengabdian • Pendidikan • Kolaborasi",
  village: "Kelurahan Kedungwuni Barat",
  university: "UIN K.H. Abdurrahman Wahid Pekalongan",
  universityShort: "UIN Gusdur Pekalongan",
  period: "Juli — September 2026",
  address: "Posko KKN 55, Jl. Raya Kedungwuni Barat No. 55",
  kelurahan: "Kedungwuni Barat",
  kecamatan: "Kedungwuni",
  kabupaten: "Kabupaten Pekalongan",
  provinsi: "Jawa Tengah 51173",
  whatsappUrl: "https://wa.me/6281234567890",
  whatsappDisplay: "+62 812-3456-7890",
  email: "kkn55.gusdur@gmail.com",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Kelurahan+Kedungwuni+Barat,+Kedungwuni,+Kabupaten+Pekalongan,+Jawa+Tengah&output=embed",
  mapsUrl:
    "https://maps.google.com/?q=Kelurahan+Kedungwuni+Barat,+Kedungwuni,+Kabupaten+Pekalongan",
  socials: {
    instagram: "https://instagram.com/",
    youtube: "https://youtube.com/",
    tiktok: "https://tiktok.com/",
    facebook: "https://facebook.com/",
    whatsapp: "https://wa.me/6281234567890",
  },
  navLinks: [
    { label: "Beranda", href: "#beranda" },
    { label: "Tentang", href: "#tentang" },
    { label: "Program Kerja", href: "#program" },
    { label: "Galeri", href: "#galeri" },
    { label: "Artikel", href: "#artikel" },
    { label: "Link Penting", href: "#tautan" },
    { label: "Kontak", href: "#kontak" },
  ],
};
